module.exports = __webpack_public_path__ + "static/img/endexam.2b641ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/endexam.png
// module id = 3rZK
// module chunks = 1